import React, { Component } from 'react'
import Select from 'react-select'
import apiService from '../../services/ApiService'

class AttendanceCycles extends Component {
    constructor() {
        super()
        this.state = {
            attendanceCyclessList: {},
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getAttendanceCyclesList()
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    getAttendanceCyclesList = () => {
        apiService.getAttendanceCyclesList()
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                     this.setState({
                        attendanceCyclessList: listData.data
                    })
                    
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }
    

    render() {
        let list = {}
        list = Object.keys(this.state.attendanceCyclessList).map((value,index) => {
            
            return {
                label : this.state.attendanceCyclessList[value],
                value : value
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                placeholder="Select Attendance Cycle"
                options={list}
                onChange={(e) => { (e) ? this.props.attendanceCyclesChange(e) : this.props.attendanceCyclesChange([])}}
                />
            </div>
        )
    }
}
export default AttendanceCycles


// WEBPACK FOOTER //
// ./src/common/DropDowns/AttendanceCycles.js